import React from 'react';
import { TypeRichEditorComponentWithoutUnresolvableLinksResponse } from '../../_generated';
import { TGeneralComponent } from '../../types/types';
import classNames from 'classnames';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import ContentBlock from '../../components/ContentBlock';
import { TPosition } from '@/types/types';
import { applyPaddings } from '@/utils/applyPaddings';

interface IRichTextWrapperProps {
    component: TGeneralComponent;
}

const RichTextWrapper: React.FC<IRichTextWrapperProps> = ({ component }) => {
    const { fields } = component as TypeRichEditorComponentWithoutUnresolvableLinksResponse;
    const inspectorProps = useContentfulInspectorMode({ entryId: component?.componentId });
    return (
        <div
            className={classNames('tw-w-full tw-flex tw-justify-center', {
                'tw-bg-bgSkyLight': fields?.backgroundColor === 'blue',
            })}
            style={applyPaddings({
                paddingTop: fields?.paddingTop,
                paddingBottom: fields?.paddingBottom,
            })}
        >
            <div className="container">
                <ContentBlock
                    inspectorProps={inspectorProps}
                    summary={fields?.content}
                    summaryPosition={fields?.contentAlignment as TPosition}
                    fullWidth={fields.type === 'Full Width Content Block'}
                    fieldId="content"
                    summaryId={component.componentId}
                />
            </div>
        </div>
    );
};

export default RichTextWrapper;
